import { useEffect, useState } from 'react';
import { createSubscription } from '@genfun/core/api/auth';
import { openTabWithUrl } from '@genfun/core/utils/openTabWithUrl';
import '../pages/Generate.css';

const BUY_BTN_STYLE = {
    width: '100%',
    marginTop: 4,
    padding: '13px 16px',
    border: 'none',
    borderRadius: 12,
    background: '#ff9000',
    color: '#000',
    fontFamily: 'inherit',
    fontSize: 14,
    fontWeight: 800,
    letterSpacing: '0.01em',
    cursor: 'pointer',
    boxShadow: '0 6px 18px rgba(255,144,0,0.3)',
};

function useLockBodyScroll(isOpen) {
    useEffect(() => {
        if (!isOpen) return;
        const html = document.documentElement;
        const body = document.body;
        const scrollbarWidth = window.innerWidth - html.clientWidth;
        const prev = {
            bodyOverflow: body.style.overflow,
            htmlOverflow: html.style.overflow,
            bodyPaddingRight: body.style.paddingRight,
        };
        body.style.overflow = 'hidden';
        html.style.overflow = 'hidden';
        if (scrollbarWidth > 0) body.style.paddingRight = `${scrollbarWidth}px`;
        return () => {
            body.style.overflow = prev.bodyOverflow;
            html.style.overflow = prev.htmlOverflow;
            body.style.paddingRight = prev.bodyPaddingRight;
        };
    }, [isOpen]);
}

export function PricingPopup({ isOpen, onClose, token, user, overlayClassName = 'popupOverlay' }) {
    useLockBodyScroll(isOpen);
    const [loading, setLoading] = useState(null);

    const handleSubscribe = (tier) => {
        if (!token || loading) return;
        setLoading(tier);
        openTabWithUrl(() => createSubscription(token, tier).then(r => r.url))
            .catch(() => {})
            .finally(() => setLoading(null));
    };

    if (!isOpen) return null;
    return (
        <div className={overlayClassName} onClick={onClose}>
            <div className="pricingPopup" onClick={e => e.stopPropagation()}>
                <button className="pricingClose" onClick={onClose}>&times;</button>
                <div className="pricingHeader">
                    <h2 className="pricingTitle">Pick a plan</h2>
                    <p className="pricingSubtitle">Unlock unlimited creating.</p>
                    {user && (
                        <div className="pricingBalance">
                            Your balance: <b>{user.credits ?? 0}</b> credits
                        </div>
                    )}
                </div>
                <div className="pricingCards">
                    <div className="pricingCard">
                        <div className="pricingCardName">Starter</div>
                        <div className="pricingCardPriceRow">
                            <span className="pricingCardPrice">$10</span>
                            <span className="pricingPer">/w</span>
                        </div>
                        <ul className="pricingFeatures">
                            <li>50 credits</li>
                            <li>≈ 16 photos or 5 videos</li>
                            <li>No watermark</li>
                        </ul>
                        <button className="pricingBuyBtn" style={BUY_BTN_STYLE} onClick={() => handleSubscribe(1)} disabled={!!loading}>
                            {loading === 1 ? 'Redirecting…' : 'Buy'}
                        </button>
                    </div>
                    <div className="pricingCard pricingCard--popular">
                        <div className="pricingBadge">Best value</div>
                        <div className="pricingCardName">Premium</div>
                        <div className="pricingCardPriceRow">
                            <span className="pricingCardPrice">$20</span>
                            <span className="pricingPer">/w</span>
                            <span className="pricingOldPrice">$60</span>
                        </div>
                        <ul className="pricingFeatures">
                            <li>200 credits</li>
                            <li>≈ 66 photos or 20 videos</li>
                            <li>Priority queue</li>
                        </ul>
                        <button className="pricingBuyBtn" style={BUY_BTN_STYLE} onClick={() => handleSubscribe(2)} disabled={!!loading}>
                            {loading === 2 ? 'Redirecting…' : 'Buy'}
                        </button>
                    </div>
                </div>
                <div className="pricingFooter">Secure checkout via Centrobill</div>
            </div>
        </div>
    );
}
